import { render } from "./ManagementAccountingView.vue?vue&type=template&id=20d724f7"
import script from "./ManagementAccountingView.vue?vue&type=script&lang=js"
export * from "./ManagementAccountingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__